import CheckCircleOutlineOutlinedIcon from "@mui/icons-material/CheckCircleOutlineOutlined";
import ErrorOutlineOutlinedIcon from "@mui/icons-material/ErrorOutlineOutlined";
import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import Modal from "@mui/material/Modal";
import { sendInvoicesOverMail } from "@queries/events.queries";
import styles from "@styles/modal/enterMail.module.css";
import { Store } from "@utils/store/ContextStore";
import { useRouter } from "next/router";
import { useContext, useState } from "react";
import { AiOutlineCloseCircle } from "react-icons/ai";
import UtsavNewModal from "src/globalModule/views/UtsavNewModal";

const EnterMail = ({ open, onClose, registrationID, userDetail }) => {
  const [email, setEmail] = useState("");
  const [showMore, setShowMore] = useState(false);
  const { state } = useContext(Store);
  const user = state?.user;
  const [loading, setLoading] = useState(false);
  const router = useRouter();
  const [errorModal, setErrorModal] = useState({
    open: false,
    heading: "",
    message: "",
    acceptMethod: () => {},
    icon: null,
    positive: false,
  });

  const getTaxInvoice = async () => {
    setLoading(true);
    const res = await sendInvoicesOverMail({
      registrationID,
      accessToken: user?.accessToken,
      email: email,
    });
    setLoading(false);
    
    if (!res?.data?.success) {
      setErrorModal({
        open: true,
        heading: "Error",
        message: res.data?.message,
        acceptMethod: () => {
          setErrorModal({ ...errorModal, open: false });
          onClose();
        },
        icon: (
          <ErrorOutlineOutlinedIcon sx={{ fontSize: "3rem", color: "red" }} />
        ),
      });
    } else {
      setErrorModal({
        open: true,
        heading: "Success",
        message: "Invoice Sent Successfully! Please Check Your Mail",
        acceptMethod: () => {
          setErrorModal({ ...errorModal, open: false });
          onClose();
          router.push(`/profile/${userDetail.uid}`);
        },
        icon: (
          <CheckCircleOutlineOutlinedIcon
            sx={{ fontSize: "3rem", color: "green" }}
          />
        ),
        positive: true,
      });
    }

    // window.location.reload();
  };
  const sent = (e) => {
    e.preventDefault();
    getTaxInvoice();
  };

  return (
    <>
      <Modal open={open} onClose={onClose}>
        <Box className={styles.container} sx={{ bgcolor: "background.paper" }}>
          <Box id="modal-modal-title" variant="h6" component="h3">
            <span>Please enter your email!! </span>
            <p className={styles.sm}>
              We will send you the link to your Invoice on this email.
            </p>
            <AiOutlineCloseCircle className={styles.close} onClick={onClose} />
          </Box>
          <form onSubmit={sent} className={styles.forms}>
            <input
              type="email"
              required
              value={email}
              placeholder="Enter your email address"
              className={styles.subInput}
              onChange={(e) => setEmail(e.target.value)}
            />
            {!loading ? (
              <button className={styles.subBtn} type="submit">
                Submit
              </button>
            ) : (
              <button className={styles.subBtn}>
                <CircularProgress
                  sx={{ color: "white", height: "15px", width: "15px" }}
                  size="small"
                />
              </button>
            )}
          </form>
        </Box>
      </Modal>
      {errorModal.open && (
        <UtsavNewModal
          open={errorModal.open}
          toggleModal={() =>
            setErrorModal((prevState) => ({
              ...prevState,
              open: true,
            }))
          }
          heading={errorModal.heading}
          message={errorModal.message}
          acceptMsg="Okay"
          onAccept={errorModal.acceptMethod}
          // rejectMsg="Cancel"
          icon={errorModal.icon}
          positive={errorModal.positive}
        />
      )}
    </>
  );
};

export default EnterMail;
